import { ThemeOptions } from '@material-ui/core';
import { Dispatch, SetStateAction, createContext } from 'react';

export interface ThemeContextProps {
  setThemeOptions: Dispatch<SetStateAction<ThemeOptions>>;
}

export const ThemeContext = createContext<ThemeContextProps>({ setThemeOptions: () => {} });
